/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Semesterid2Inputs */

const en__field_semesterid2 = /** @type {(inputs: _Field_Semesterid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester ID`)
};

const de__field_semesterid2 = /** @type {(inputs: _Field_Semesterid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester-ID`)
};

/**
* | output |
* | --- |
* | "Semester ID" |
*
* @param {_Field_Semesterid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_semesterid2 = /** @type {((inputs?: _Field_Semesterid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Semesterid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_semesterid2(inputs)
	return de__field_semesterid2(inputs)
});
export { _field_semesterid2 as "_field_semesterID" }